<template>
  <a-modal
    title="编辑药房管理1"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['pharmacyId']" /></a-form-item>
        <a-form-item
          label="药房名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药房名称" v-decorator="['pharmacyName', {rules: [{required: true, message: '请输入药房名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="类型(1-内配2-外配)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <!-- <a-input placeholder="请输入类型(1-内配2-外配)" v-decorator="['type', {rules: [{required: true, message: '请输入类型(1-内配2-外配)！'}]}]" /> -->
        </a-form-item>
        <a-form-item
          label="是否支持物流配送(0-否1-是)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否支持物流配送(0-否1-是)" v-decorator="['isDelivery', {rules: [{required: true, message: '请输入是否支持物流配送(0-否1-是)！'}]}]" />
        </a-form-item>
        <a-form-item
          label="是否推荐"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否推荐" v-decorator="['isRecom', {rules: [{required: true, message: '请输入是否推荐！'}]}]" />
        </a-form-item>
        <a-form-item
          label="电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入电话" v-decorator="['phone', {rules: [{required: true, message: '请输入电话！'}]}]" />
        </a-form-item>
        <a-form-item
          label="所属地区省行政编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入所属地区省行政编码" v-decorator="['regionProvinceCode', {rules: [{required: true, message: '请输入所属地区省行政编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="所属地区市行政编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入所属地区市行政编码" v-decorator="['regionCityCode', {rules: [{required: true, message: '请输入所属地区市行政编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="省行政编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入省行政编码" v-decorator="['provinceCode', {rules: [{required: true, message: '请输入省行政编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="市行政编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入市行政编码" v-decorator="['cityCode', {rules: [{required: true, message: '请输入市行政编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="区行政编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入区行政编码" v-decorator="['areaCode', {rules: [{required: true, message: '请输入区行政编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="详细地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入详细地址" v-decorator="['addressDetail', {rules: [{required: true, message: '请输入详细地址！'}]}]" />
        </a-form-item>
        <a-form-item
          label="描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入描述" v-decorator="['pharmacyDesc', {rules: [{required: true, message: '请输入描述！'}]}]" />
        </a-form-item>
        <a-form-item
          label="是否启用"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否启用" v-decorator="['useflag', {rules: [{required: true, message: '请输入是否启用！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { baPharmacyEdit } from '@/api/modular/interhospital/bapharmacy/baPharmacyManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              pharmacyId: record.pharmacyId,
              pharmacyName: record.pharmacyName,
              type: record.type,
              isDelivery: record.isDelivery,
              isRecom: record.isRecom,
              phone: record.phone,
              regionProvinceCode: record.regionProvinceCode,
              regionCityCode: record.regionCityCode,
              provinceCode: record.provinceCode,
              cityCode: record.cityCode,
              areaCode: record.areaCode,
              addressDetail: record.addressDetail,
              pharmacyDesc: record.pharmacyDesc,
              useflag: record.useflag
            }
          )
        }, 100)
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            baPharmacyEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
